import Model from 'flarum/common/Model';

// Another card of the cartothèque, named in a warning (cardLabels).

export default class CartothequeEntry extends Model {
  gbifId() {
    return Model.attribute('gbifId').call(this);
  }
  no() {
    return Model.attribute('no').call(this);
  }
  vernacularName() {
    return Model.attribute('vernacularName').call(this);
  }
  toPrint() {
    return Model.attribute('toPrint').call(this);
  }
  createdAt() {
    return Model.attribute('createdAt', Model.transformDate).call(this);
  }

  // {canonicalName, scientificName, author, family, phylum} or null (lookup failed) -
  // cached server-side on gbifId's own .set(), see
  // CartothequeEntryResource::fields()'s speciesDisplay field.
  speciesDisplay() {
    return Model.attribute('speciesDisplay').call(this);
  }

  // The synonym printed beside its name, or null - see
  // CartothequeEntry::assignSynonym() on the PHP side.
  synonymGbifId() {
    return Model.attribute('synonymGbifId').call(this);
  }
  synonymDisplay() {
    return Model.attribute('synonymDisplay').call(this);
  }

  // {gbifId, canonicalName, scientificName, author, family} or null - set by
  // the champis-exhibitions:check-cartotheque-species scheduled job when
  // gbifId is a GBIF synonym, not the accepted name. See
  // CartothequeEntryResource::fields()'s suggestedSpecies field.
  suggestedSpecies() {
    return Model.attribute('suggestedSpecies').call(this);
  }

  // What correcting to suggestedSpecies would duplicate, in the whole
  // cartothèque - null without a suggestion. See CartothequeEntryResource::
  // suggestionConflicts().
  suggestionConflicts() {
    return Model.attribute('suggestionConflicts').call(this);
  }

  // Sanitized HTML (see CartothequeEntryResource::purifyDescription()) shown
  // on the public, unauthenticated page this card's printed QR code links
  // to (see CardPdfBuilder's own card_show_qr_code handling) - null/empty
  // means no QR code at all, not just an empty one.
  description() {
    return Model.attribute('description').call(this);
  }
  society() {
    return Model.hasOne('society').call(this);
  }
  toxicity() {
    return Model.hasOne('toxicity').call(this);
  }
}
flarum.reg.add('champis-exhibitions', 'common/models/CartothequeEntry', CartothequeEntry);